import DefaultApiService from "./default";
import { normalizePartnerReferralFilterApiResponse } from "../utils/partnerReferralFilterApi";

const BASE = "SLN/SolarentOperator/CheckNewRequest";

const OperatorProjectWorkspaceApi = {
  getPartnerReferralFilterOptions: async () => {
    const res = await DefaultApiService.getApi(`${BASE}/GetPartnerReferralFilterOptions`);
    return normalizePartnerReferralFilterApiResponse(res);
  },
};

export default OperatorProjectWorkspaceApi;
